<h1 *ngIf="!dm" class="info__title">Vaše mnenje šteje!</h1>
<p *ngIf="!dm" class="info__content">Prosimo, ocenite vaše kulinarično doživetje v izbrani restavraciji. </p>

<h1 *ngIf="dm" class="info__title">OCENITE SVOJO IZKUŠNJO</h1>
<p *ngIf="dm" class="info__content">Vaše mnenje nam veliko pomeni. Prosimo, da ocenite svojo izkušnjo. </p>


<ion-grid *ngIf="loading"> 
  <ion-row><ion-col class="ion-align-self-center"><ion-spinner name="crescent"></ion-spinner></ion-col></ion-row>
</ion-grid>

<ng-container *ngIf="survey && booking">

<div class="ion-padding-horizontal" *ngIf="real">
    <div class="popular-saloons" style="margin-bottom: 0px">
      <ion-img class="popular-saloons__img" [src]="( real.galleryFirst.fileName | ppImage )"></ion-img>
      <h4 class="popular-saloons__name">{{ real?.getComposedName() }}</h4>
      <p class="popular-saloons__address ion-no-margin">{{ real.address }}</p>
      <!--<p class="popular-saloons__address">{{ booking.start | date:"fullDate" }} ob {{ booking.start | date:"shortTime" }}h</p>-->
    </div>
</div>

<form [formGroup]="form" (ngSubmit)="onFormSubmit()" >

  <div *ngIf="form.get( doneQuestionId )?.value === true" style="margin-bottom:25px" class="ion-text-center"> 
    <a (click)="form.get( doneQuestionId ).setValue(false); $event.stopPropagation();"><small>Restavracije sploh nisem obiskal!?</small></a>
  </div>


  <ng-container *ngFor="let question of survey?.questions">

    <div [hidden]="( ( ( question.id === '27' || question.id === '28' ) && form.get('27')?.value === true ) || ( ( question.id !== '27' && question.id !== '28' ) && form.get('27')?.value === false ) ) ">

    <h2 class="info__title">{{ question.title }}</h2>
    <p class="info__content">{{ question.description }}</p>

    <container-element [ngSwitch]="question.getClassName()">

    <ion-list *ngSwitchCase="'YesNoQuestion'">
      <ion-radio-group [formControlName]="question.id">

        <ion-item>
          <ion-label>{{ question.yes }}</ion-label>
          <ion-radio color="secondary" slot="start" [value]="true"></ion-radio>
        </ion-item>

        <ion-item>
          <ion-label>{{ question.no }}</ion-label>
          <ion-radio color="secondary" slot="start" [value]="false"></ion-radio>
        </ion-item>

      </ion-radio-group>
    </ion-list>

    <ion-textarea [maxlength]="question.maxLength" [formControlName]="question.id" style="border:1px solid black;" placeholder="" *ngSwitchCase="'EssayQuestion'"></ion-textarea>

    <ion-list *ngSwitchCase="'SelectQuestion'">

      <ion-radio-group [formControlName]="question.id">

        <ion-item *ngFor="let option of question.selectQuestionOptions">
          <ion-label>{{ option.caption }}</ion-label>
          <ion-radio color="secondary" slot="start" [value]="option.id"></ion-radio>
        </ion-item>

      </ion-radio-group>

    </ion-list>

    <div *ngSwitchCase="'RatingQuestion'">
      <ionic-rating-component #rating [formControlName]="question.id"
        activeIcon = "star"
        defaultIcon = "star-outline"
        activeColor = "black" 
        defaultColor = "#black"
        readonly="false"
        rating="0"
        fontSize = "48px"
        (ratingChanged)="onRatingChange($event)">
      </ionic-rating-component>
      <p class="info__content">
        <span *ngIf="1 === form.get( question.id )?.value">{{ question.one }}</span>
        <span *ngIf="2 === form.get( question.id )?.value">{{ question.two }}</span>
        <span *ngIf="3 === form.get( question.id )?.value">{{ question.three }}</span>
        <span *ngIf="4 === form.get( question.id )?.value">{{ question.four }}</span>
        <span *ngIf="5 === form.get( question.id )?.value">{{ question.five }}</span>
      </p>
    </div>


    </container-element>

    <div class="info__error" *ngIf="tryToSubmit && form.get( question.id ).invalid && !!form.get( question.id ).errors?.required">
      Manjka odgovor!
    </div>

    <br />

    </div>

  </ng-container>


<div>
  


</div>


<ion-button *ngIf="!loading" expand="full" tabindex="12" type="submit" class="form__submit btn--large">POŠLJI</ion-button>
<ion-button *ngIf="loading" disabled="true" expand="full" tabindex="12" type="submit" class="form__submit btn--large"><ion-spinner name="crescent"></ion-spinner></ion-button>

</form>

</ng-container>